import React from 'react';

function PlaylistCard({ playlist, styles }) {
  const formatNumber = (num) => {
    if (!num) return '0';
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  const getPlatformColor = (platform) => {
    return platform === 'spotify' ? '#1DB954' : '#EF5466';
  };

  return (
    <div style={styles.card}>
      {playlist.images?.[0] && (
        <div style={{ position: 'relative' }}>
          <img
            src={playlist.images[0].url}
            alt={playlist.name}
            style={styles.cardImage}
          />
          <div style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: getPlatformColor(playlist.platform),
            color: 'white',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '12px',
            textTransform: 'capitalize'
          }}>
            {playlist.platform}
          </div>
        </div>
      )}
      <div style={styles.cardContent}>
        <h3 style={styles.cardTitle}>{playlist.name}</h3>
        <p style={styles.cardSubtitle}>
          Par {playlist.owner?.display_name || 'Utilisateur inconnu'}
        </p>
        {playlist.description && (
          <p style={styles.cardDescription}>
            {playlist.description}
          </p>
        )}
        <div style={styles.stats}>
          <span>
            {playlist.tracks?.total || 0} titres
          </span>
          <span>
            {formatNumber(playlist.followers?.total)} {playlist.platform === 'deezer' ? 'fans' : 'followers'}
          </span>
        </div>
        {(playlist.external_urls?.spotify || playlist.external_urls?.deezer) && (
          <a
            href={playlist.external_urls?.spotify || playlist.external_urls?.deezer}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...styles.button,
              backgroundColor: getPlatformColor(playlist.platform)
            }}
          >
            Ouvrir dans {playlist.platform === 'spotify' ? 'Spotify' : 'Deezer'}
          </a>
        )}
      </div>
    </div>
  );
}

export default PlaylistCard;